import { useCurrentRefinements } from "react-instantsearch-core";
import { XClose } from "untitledui-js-base";

export const SelectedFilters = () => {
  const { items, refine } = useCurrentRefinements({
    excludedAttributes: ["boomEnrollmentStatus"]
  });

  const refinements = items.flatMap((item) => item.refinements);

  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {refinements.map((refinement) => (
        <div
          key={refinement.label}
          className="flex items-center justify-center gap-2 rounded-lg border border-alpha-40 bg-primary-20 px-4 py-2"
        >
          <p className="text-sm font-medium text-primary-500 truncate">
            {refinement.label}
          </p>
          <button
            type="button"
            onClick={() => {
              refine(refinement);
            }}
          >
            <XClose size="18" className="stroke-primary-500" />
          </button>
        </div>
      ))}
    </div>
  );
};
